export const FileDownlaod = (data, filename, mime) => {
  var blob = new Blob([data], {type: mime || 'application/octet-stream'});
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
      // IE workaround for "HTML7007: One or more blob URLs were 
      // revoked by closing the blob for which they were created. 
      // These URLs will no longer resolve as the data backing 
      // the URL has been freed."
      window.navigator.msSaveBlob(blob, filename);
  }
  else {
      var blobURL = window.URL.createObjectURL(blob);
      var tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = blobURL;
      tempLink.setAttribute('download', filename); 
      
      // Safari thinks _blank anchor are pop ups. We only want to set _blank
      // target if the browser does not support the HTML5 download attribute.
      // This allows you to download files in desktop safari if pop up blocking 
      // is enabled.
      if (typeof tempLink.download === 'undefined') {
          tempLink.setAttribute('target', '_blank');
      }
      
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobURL);
  }
}

export const FileDownlaodWithURL = (url, fileName, mime) => {
  let browserName;
  const userAgent = navigator.userAgent;
  switch (true) {
    case /Trident|MSIE/.test(userAgent):
        browserName = 'ie';
        break;

    case /Edge/.test(userAgent):
        browserName = 'edge';
        break;

    case /Chrome/.test(userAgent):
        browserName = 'chrome';
        break;

    case /Safari/.test(userAgent):
        browserName = 'safari';
        break;

    case /Firefox/.test(userAgent):
        browserName = 'firefox';
        break;

    case /Opera/.test(userAgent):
        browserName = 'opera';
        break;

    default:
        browserName = 'unknown';
  };
  //ie 브라우저 및 EDGE 브라우저 
  if (browserName === 'ie' || browserName === 'edge') {
    //ie11
    var _window = window.open(url, "_blank");
    _window.document.close();
    _window.document.execCommand('SaveAs', true, fileName || url);
    _window.close();
  } else {
    // var blob = new Blob([url], {type: mime || 'jpg/image'});
    // var blobURL = window.URL.createObjectURL(blob);
  return new Promise((resolve, reject) => {
    
    try{
      console.log('%ctry to download file from url...', 'background-color: orange; color: white; font-weight: bold');

      if(fileName){
        var link = document.createElement("a");
        // // Construct the uri
        link.href = url;
        link.download = fileName;

        // Safari thinks _blank anchor are pop ups. We only want to set _blank
        // target if the browser does not support the HTML5 download attribute.
        // This allows you to download files in desktop safari if pop up blocking 
        // is enabled.
        if (typeof link.download === 'undefined') {
          link.setAttribute('target', '_blank');
        }

        document.body.appendChild(link);
        link.click();
        // Cleanup the DOM
        document.body.removeChild(link);

    }else{
      var tempLink = document.createElement('a');
      const urlArray = url.split('/');
      const downNameIndex = urlArray.length -1;

      tempLink.style.display = 'none';
      // tempLink.type = 'application/octet-stream';
      tempLink.href = url;
      tempLink.download = urlArray[downNameIndex];
      // Safari thinks _blank anchor are pop ups. We only want to set _blank
      // target if the browser does not support the HTML5 download attribute.
      // This allows you to download files in desktop safari if pop up blocking 
      // is enabled.
      if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank');
      }
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(url);
    }
      console.log('%cdownload request success!!', 'background-color: orange; color: white; font-weight: bold');
      resolve();
    } catch (e){
      reject(e);
    }
  })
}
}



// WEBPACK FOOTER //
// ./src/util/FileDownload.js